export enum IconType {
  NONE = 0,
  INFO = 1
}
